// Tooltip placement for ui-tooltip: plain geometry, so it is unit tested.

const ORDER = {
  top: ['top', 'bottom', 'right', 'left'],
  bottom: ['bottom', 'top', 'right', 'left'],
  right: ['right', 'left', 'top', 'bottom'],
  left: ['left', 'right', 'top', 'bottom'],
}

const clamp = (value, min, max) => Math.min(Math.max(value, min), Math.max(min, max))

/**
 * Where a tooltip of `size` ({width, height}) goes beside `target` (a DOMRect) in a `view` ({width, height}):
 * on the first side, starting at `side`, with room for it, else the roomiest; slid along that side to stay
 * `margin` inside the view, its arrow (`arrow`, px from the tooltip's left or top edge) on the center of the
 * target's visible part. Returns {side, left, top, arrow}.
 */
export function placeTip(target, size, view, { side = 'top', gap = 8, margin = 8, inset = 12 } = {}) {
  const room = {
    top: target.top - gap - margin - size.height,
    bottom: view.height - margin - target.bottom - gap - size.height,
    left: target.left - gap - margin - size.width,
    right: view.width - margin - target.right - gap - size.width,
  }
  const order = ORDER[side] || ORDER.top
  const chosen = order.find((s) => room[s] >= 0) || order.reduce((best, s) => (room[s] > room[best] ? s : best))
  const cx = (clamp(target.left, 0, view.width) + clamp(target.right, 0, view.width)) / 2
  const cy = (clamp(target.top, 0, view.height) + clamp(target.bottom, 0, view.height)) / 2
  let left, top, arrow
  if (chosen === 'top' || chosen === 'bottom') {
    left = clamp(cx - size.width / 2, margin, view.width - margin - size.width)
    top = clamp(chosen === 'top' ? target.top - gap - size.height : target.bottom + gap, margin, view.height - margin - size.height)
    arrow = clamp(cx - left, inset, size.width - inset)
  } else {
    top = clamp(cy - size.height / 2, margin, view.height - margin - size.height)
    left = clamp(chosen === 'left' ? target.left - gap - size.width : target.right + gap, margin, view.width - margin - size.width)
    arrow = clamp(cy - top, inset, size.height - inset)
  }
  return { side: chosen, left: Math.round(left), top: Math.round(top), arrow: Math.round(arrow) }
}
